import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import Layout from '../../../layout';
import Register from './register';
import WhyBourse from './whyBourse';
import TypesOfMarket from './TypesOfMarket';
import ServicesKala from './servicesKala';
import StepKala from './stepKala';
import Download from './download';

const useStyles = makeStyles((theme) => ({

}))


export default function Index() {

    const classes = useStyles()

    return (
        <Layout>
            <Register />
            <WhyBourse />
            <TypesOfMarket />
            <ServicesKala />
            <StepKala />
            <Download />
            <br />
            <br />
            <br />
        </Layout>
    )
}


let data1 = {
    title: "معرفی بورس کالا",
    content: `
    شرکت بورس کالای ایران در آذر 1385 با ادغام بورس فلزات و بورس کالای کشاورزی تشکیل شد و از مهر 1386 کار خود را زیر نظر سازمان بورس و اوراق بهادار آغاز کرد. بورس كالا، بازار منسجمی است كه تعداد زیادی از عرضه‌كنندگان، كالای خود را به خریداران عرضه می‌کنند. در این بورس، کالاها در چند گروه نظیر محصولات فولادی، کشاورزی، پتروشیمی و فرآورده های نفتی دادوستد می‌شوند.
    کارگزاری پویان با ارائه خدمات متنوع، یکی از برترین کارگزاران فعال در بورس کالا ایران است. پویان براساس رتبه‌بندی کارگزاران توسط سازمان بورس و اوراق بهادار، همواره حائز رده‌های اول در میان کارگزاری‌های رتبه «الف» است. تعهد در انجام سفارشات، ارائه بهترین خدمات مشاوره به مشتریان و همچنین سرعت و دقت در اجرای سفارشات از اصول اولیه 
     در تعامل با مشتریان است.
    `,
    src: "kala.png"
}

const data2 = {
    title: 'روند پیدایش و تکامل بورس‌های کالا در جهان',
    desc: `
    بررسی روند پیدایش و تکامل بورس‌های کالا در جهان حاکی از آن است که این‌گونه بازارها در عرصه اقتصاد کشورها از قرن ۱۹ به بعد در پی پاسخ‌گویی به برخی از نیازمندی‌های اقتصادی و در بسیاری موارد رفع برخی تنگناها و موانع در بازار کالاهای مختلف بوده است.
    در واقع نارسایی‌های بازارهای سنتی در شکل‌ نوسانات کاذب و عدم شفافیت در کشف قیمت و فقدان تضمین‌های لازم برای معامله‌گران از مهم‌ترین دلایل راه‌اندازی بورس‌های کالایی در کشورهای جهان بوده است.
    در چنین شرایطی وجود بورس‌های کالایی و استفاده از ابزارهای مشتقه به پدید آمدن یک نظام سازمان‌یافته دادوستد و توزیع کالاها در کشورهای مختلف منجر شده و راه ورود به بازارهای جهانی را برای کشورها تسهیل کرده است.
    `,
    desc2: `
    از این‌رو هم‌اکنون صدها بورس‌کالایی مدرن در سراسر جهان دایر است که از قدیمی‌ترین آن‌ها می‌توان به بورس معروف و تجاری شیکاگو(CME) با ۱۷۰ سال سابقه، بورس فلزات لندن(LME) با ۱۳۰ سال سابقه، بورس‌کالای نیویورک(NYMEX)، بورس‌کالای توکیو (TOCOM)، بورس کالای شانگهای(SHFE)، بورس کالای هند(MCX) اشاره کرد.
    `,
    btn: '',
}

const data3 = {
    title: 'انواع بازارهای کالا',
    desc:'بورس کالا بازاری است متشکل و سازمان یافته که در آن به طور منظم کالاهای معین با روش‌هایی از قبل تعریف شده مورد معامله قرار می‌گیرند. در این بازار تعداد زیادی عرضه‌کننده و خریدار از طریق کارگزاران اقدام به معامله می‌کنند، در حال حاضر بورس کالا در ایران در چند حوزه فعالیت دارد که البته در حال گسترش در حوزه‌های دیگر نیز است.',
    data: [
        {
            title: 'بازار مالی',
            desc: 'بازار مالی در بورس کالا از سه زیر مجموعه اصلی شامل «سلف موازی استاندارد»، «گواهی سپرده کالایی» و «صندو‌ق‌های کالایی» تشکیل شده است. بازار مالی در بورس کالا با هدف جذب هرچه بیشتر سرمایه و تامین مالی مورد نیاز شکل گرفته است.',
        },
       
        {
            title: 'بازار مشتقه',
            desc: 'بازار مشتقه با بهره‌مندی از ابزارهایی نظیر قراردادهای آتی و اختیار معامله، کارکرد متنوعی برای طیف گسترده‌ای از سرمایه‌گذاران دارد. در این بازار یک دارایی پایه که قراردادها بر روی آن منتشر می‌شوند، تعریف می‌شود. این دارایی پایه می‌تواند محصولات کشاورزی، انواع فلزات و انواع فراورده‌های نفتی باشد. در بورس کالا نخستین بازار قراردادهای آتی روی سکه و محصولات کشاورزی مانند زعفران شکل گرفت. پس از مدتی در این نوع معاملات محصولات دیگری مثل پسته و زیره نیز افزوده شدند.',
        },
       
        {
            title: 'بازار فیزیکی',
            desc: 'بازار فیزیکی یکی از بخش‌های مهم بورس کالا است. در بازار فیزیکی تحویل کالا مشابه بازار سنتی انجام می‌شود، البته قوانین و سازوکارهای به‌خصوصی نیز برای آن تعریف شده است. در بازار فیزیکی عرضه‌کننده مواد خام (پتروشیمی‌ها، فلزات و محصولات کشاورزی) و مصرف کننده با نظر گرفتن قوانین حاکم بر بورس کالا و با مزیت شفافیت در قیمت‌ها وارد معامله می‌شوند.',
        },
       
        {
            title: '',
            desc: '',
        },
    ]
}
